import { createpaymentRequestReminderAsync } from "@api";
import { DEFAULT_REMINDER_SUBJECT, buildDefaultReminderMessage } from "./reminderDefaults";

// The webpay pay link for a payment request (portal host → webpay host).
export const buildPaymentUrl = (id) =>
  window.location.origin.replace("portal", "webpay") + "/pay/" + id;

// Which channel a one-click reminder should use: prefer email, fall back to SMS. Null when the
// request has neither on file — the caller should open the modal to collect a recipient.
export const preferredReminderChannel = (detail) => {
  if (detail?.email?.to) return "Email";
  if (detail?.sms?.to) return "Sms";
  return null;
};

// Send the default reminder for a payment request on the given channel. Throws on failure.
// Always tagged aiSuggested — this path is only used from the Today's-tasks (suggestion) flow.
export const sendDefaultReminder = (detail, channel) => {
  const message = buildDefaultReminderMessage(detail);
  const isEmail = channel === "Email";

  return createpaymentRequestReminderAsync(
    detail.id,
    buildPaymentUrl(detail.id),
    channel,
    isEmail ? null : detail.sms?.to ?? null,
    isEmail ? detail.email?.to ?? null : null,
    isEmail ? DEFAULT_REMINDER_SUBJECT : null,
    isEmail ? null : message,
    isEmail ? message : null,
    true,
  );
};
